<template>
	<div class="SISStudentMedical">
		<div class="row">
			<div class="col-xs-12">
				<ValidationObserver
					ref="observer"
					v-slot="{ handleSubmit, invalid }"
				>
					<panel-basic :title="title"
											:collapsable="true"
											id="panel"
											class="rounded-top"
											panel-class="full-height"
											style="border-radius: 25px;"
											:helpText="helpText"
					>
						<!-- Insurance Information -->
						<!-- Primary Insurance -->
						<panel-basic title="Primary Insurance" v-if="showInsuranceFlag"
												:collapsable="true"
												id="primaryInsurance"
												class="rounded-top"
												panel-class="full-height"
												style="border-radius: 25px 25px 0 0;">
							<div class="row">
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:30"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="insuranceNameOne">
											{{ insuranceCompanyText }}
										</label>
										<input
											type="text"
											maxlength="30"
											class="form-control"
											name="insuranceNameOne"
											:aria-label="insuranceCompanyText"
											v-model="formData.SIS_MEDICAL.INSURANCE_COMPANY"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.SIS_MEDICAL.INSURANCE_COMPANY ) > 30
											}"
										>
											{{ countCharacterLength( formData.SIS_MEDICAL.INSURANCE_COMPANY ) }}/30
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', insuranceCompanyText ) }}
										</span>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:30"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="policyNumberOne">
											{{ policyNumberText }}
										</label>
										<input
											type="text"
											maxlength="30"
											class="form-control"
											name="policyNumberOne"
											:aria-label="policyNumberText"
											v-model="formData.SIS_MEDICAL.INSURANCE_POLICY_NO"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.SIS_MEDICAL.INSURANCE_POLICY_NO ) > 30
											}"
										>
											{{ countCharacterLength( formData.SIS_MEDICAL.INSURANCE_POLICY_NO ) }}/30
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', policyNumberText ) }}
										</span>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:30"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="idNumberOne">
											{{ idNumberText }}
										</label>
										<input
											type="text"
											maxlength="30"
											class="form-control"
											name="idNumberOne"
											:aria-label="idNumberText"
											v-model="formData.SIS_MEDICAL.HEALTH_CARD_NUMBER"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.SIS_MEDICAL.HEALTH_CARD_NUMBER ) > 30
											}"
										>
											{{ countCharacterLength( formData.SIS_MEDICAL.HEALTH_CARD_NUMBER ) }}/30
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', idNumberText ) }}
										</span>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:30"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="groupNumberOne">
											{{ groupNumberText }}
										</label>
										<input
											type="text"
											maxlength="30"
											class="form-control"
											name="groupNumberOne"
											:aria-label="groupNumberText"
											v-model="formData.SIS_MEDICAL.GROUP_POLICY_NO"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.SIS_MEDICAL.GROUP_POLICY_NO ) > 30
											}"
										>
											{{ countCharacterLength( formData.SIS_MEDICAL.GROUP_POLICY_NO ) }}/30
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', groupNumberText ) }}
										</span>
									</ValidationProvider>
								</div>
							</div>
						</panel-basic>
						<!-- Secondary Insurance -->
						<panel-basic title="Secondary Insurance" v-if="showInsuranceFlag"
												:collapsable="true"
												id="secondaryInsurance"
												class="rounded-top"
												panel-class="full-height"
												style="border-radius: 25px 25px 0 0;">
							<div class="row">
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:30"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="insuranceNameTwo">
											{{ insuranceCompanyText }}
										</label>
										<input
											type="text"
											maxlength="30"
											class="form-control"
											name="insuranceNameTwo"
											:aria-label="insuranceCompanyText"
											v-model="formData.SIS_MEDICAL.INSURANCE_COMPANY_2"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.SIS_MEDICAL.INSURANCE_COMPANY_2 ) > 30
											}"
										>
											{{ countCharacterLength( formData.SIS_MEDICAL.INSURANCE_COMPANY_2 ) }}/30
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', groupNumberText ) }}
										</span>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:30"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="policyNumberTwo">
											{{ policyNumberText }}
										</label>
										<input
											type="text"
											maxlength="30"
											class="form-control"
											name="policyNumberTwo"
											:aria-label="policyNumberText"
											v-model="formData.SIS_MEDICAL.INSURANCE_POLICY_NO_2"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.SIS_MEDICAL.INSURANCE_POLICY_NO_2 ) > 30
											}"
										>
											{{ countCharacterLength( formData.SIS_MEDICAL.INSURANCE_POLICY_NO_2 ) }}/30
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', groupNumberText ) }}
										</span>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:30"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="idNumberTwo">
											{{ idNumberText }}
										</label>
										<input
											type="text"
											maxlength="30"
											class="form-control"
											name="idNumberTwo"
											:aria-label="idNumberText"
											v-model="formData.SIS_MEDICAL.HEALTH_CARD_NUMBER_2"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.SIS_MEDICAL.HEALTH_CARD_NUMBER_2 ) > 30
											}"
										>
											{{ countCharacterLength( formData.SIS_MEDICAL.HEALTH_CARD_NUMBER_2 ) }}/30
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', idNumberText ) }}
										</span>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:30"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="groupNumberTwo">
											{{ groupNumberText }}
										</label>
										<input
											type="text"
											maxlength="30"
											class="form-control"
											name="groupNumberTwo"
											:aria-label="groupNumberText"
											v-model="formData.SIS_MEDICAL.GROUP_POLICY_NO_2"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.SIS_MEDICAL.GROUP_POLICY_NO_2 ) > 30
											}"
										>
											{{ countCharacterLength( formData.SIS_MEDICAL.GROUP_POLICY_NO_2 ) }}/30
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', groupNumberText ) }}
										</span>
									</ValidationProvider>
								</div>
							</div>
						</panel-basic>
						<div class="row" v-if="showHospitalPreferenceFlag">
							<div class="col-xs-12">
								<ValidationProvider ref="provider">
									<label for="hospitalPreference">
										{{ hospitalPreferenceText }}
									</label>
									<select
										name="hospitalPreference"
										:aria-label="hospitalPreferenceText"
										class="form-control"
										v-model="formData.SIS_MEDICAL.HOSPITAL_PREFERENCE"
										:disabled="isReadOnly"
									>
										<option v-for="(hospital, hospitalIndex) in hospitals"
														:key="`hospital_${hospitalIndex}`"
														:value="hospital.HOSPITAL_CODE">
											{{ hospital.HOSPITAL_DESC }}
										</option>
									</select>
								</ValidationProvider>
							</div>
						</div>
						<br />
						<!-- Primary Care Physician -->
						<panel-basic title="Primary Care Physician"
							v-if="showPhysicianFlag"
												:collapsable="true"
												id="primaryCarePhysician"
												class="rounded-top"
												panel-class="full-height"
												style="border-radius: 25px 25px 0 0;">
							<div class="row">
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:50"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="physicianName">
											{{ physicianNameText }}
										</label>
										<input
											type="text"
											name="physicianName"
											maxlength="50"
											class="form-control"
											:aria-label="physicianNameText"
											v-model="formData.PHYSICIANS.PHYSICIAN_NAME"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_NAME ) > 50
											}"
										>
											{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_NAME ) }}/50
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', physicianNameText ) }}
										</span>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<div class="row">
										<div class="col-xs-9">
											<ValidationProvider
												rules="max:15"
												ref="provider"
												v-slot="{ errors }"
											>
												<label for="physicianPhoneNumber">
													{{ physicianPhoneText }}
												</label>
												<input
													type="text"
													name="physicianPhoneNumber"
													maxlength="15"
													class="form-control"
													:aria-label="physicianPhoneText"
													v-model="formData.PHYSICIANS.PHYSICIAN_PHONE_NO"
													:disabled="isReadOnly"
												/>
												<small
													:class="{
														charactercount: true,
														errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_PHONE_NO ) > 15
													}"
												>
													{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_PHONE_NO ) }}/15
												</small>
												<span class="text-danger" v-if="errors.length">
													{{ errors[0].replace( '{field}', physicianPhoneText ) }}
												</span>
											</ValidationProvider>
										</div>
										<div class="col-xs-3">
											<ValidationProvider
												rules="max:5"
												ref="provider"
												v-slot="{ errors }"
											>
												<label for="physicianPhoneExtension">
													{{ extText }}
												</label>
												<input
													type="text"
													name="physicianPhoneExtension"
													maxlength="5"
													class="form-control"
													:aria-label="phoneNumberExtensionText"
													v-model="formData.PHYSICIANS.PHYSICIAN_PHONE_EXT"
													:disabled="isReadOnly"
												/>
												<small
													:class="{
														charactercount: true,
														errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_PHONE_EXT ) > 5
													}"
												>
													{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_PHONE_EXT ) }}/5
												</small>
												<span class="text-danger" v-if="errors.length">
													{{ errors[0].replace( '{field}', 'Physician Phone Ext' ) }}
												</span>
											</ValidationProvider>
										</div>
									</div>
								</div>
								<div class="col-xs-12 col-md-4">
									<div class="row">
										<div class="col-xs-9">
											<ValidationProvider
												rules="max:15"
												ref="provider"
												v-slot="{ errors }"
											>
												<label for="physicianFaxNumber">
													{{ physicianFaxText }}
												</label>
												<input
													type="text"
													name="physicianFaxNumber"
													maxlength="15"
													class="form-control"
													:aria-label="physicianFaxNumberText"
													v-model="formData.PHYSICIANS.PHYSICIAN_FAX_NO"
													:disabled="isReadOnly"
												/>
												<small
													:class="{
														charactercount: true,
														errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_FAX_NO ) > 15
													}"
												>
													{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_FAX_NO ) }}/15
												</small>
												<span class="text-danger" v-if="errors.length">
													{{ errors[0].replace( '{field}', physicianFaxText ) }}
												</span>
											</ValidationProvider>
										</div>
										<div class="col-xs-3">
											<ValidationProvider
												rules="max:5"
												ref="provider"
												v-slot="{ errors }"
											>
												<label for="physicianFaxExtension">
													{{ extText }}
												</label>
												<input
													type="text"
													name="physicianFaxExtension"
													maxlength="5"
													class="form-control"
													:aria-label="physicianFaxNumberExtensionText"
													v-model="formData.PHYSICIANS.PHYSICIAN_FAX_EXT"
													:disabled="isReadOnly"
												/>
												<small
													:class="{
														charactercount: true,
														errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_FAX_EXT ) > 5
													}"
												>
													{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_FAX_EXT ) }}/5
												</small>
												<span class="text-danger" v-if="errors.length">
													{{ errors[0].replace( '{field}', 'Physician Fax Ext' ) }}
												</span>
											</ValidationProvider>
										</div>
									</div>
								</div>
								<!-- Address -->
								<div class="row" style="margin: 0;">
									<div class="col-xs-12">
										<br />
										<panel-basic title="Address"
																:collapsable="true"
																id="physicianAddress"
																class="rounded-top"
																style="border-radius: 25px 25px 0 0;">
											<div class="row">
												<div class="col-xs-12 col-lg-6">
													<ValidationProvider
														rules="max:40"
														ref="provider"
														v-slot="{ errors }"
													>
														<label for="physicianAddressOne">
															{{ addressOneText }}
														</label>
														<input
															type="text"
															name="physicianAddressOne"
															maxlength="40"
															class="form-control"
															:aria-label="addressOneText"
															v-model="formData.PHYSICIANS.PHYSICIAN_ADDRESS_1"
															:disabled="isReadOnly"
														/>
														<small
															:class="{
																charactercount: true,
																errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_1 ) > 40
															}"
														>
															{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_1 ) }}/40
														</small>
														<span class="text-danger" v-if="errors.length">
															{{ errors[0].replace( '{field}', 'Physician Address 1' ) }}
														</span>
													</ValidationProvider>
												</div>
												<div class="col-xs-12 col-lg-6">
													<ValidationProvider
														rules="max:40"
														ref="provider"
														v-slot="{ errors }"
													>
														<label for="physicianAddressTwo">
															{{ addressTwoText }}
														</label>
														<input
															type="text"
															name="physicianAddressTwo"
															maxlength="40"
															class="form-control"
															:aria-label="addressTwoText"
															v-model="formData.PHYSICIANS.PHYSICIAN_ADDRESS_2"
															:disabled="isReadOnly"
														/>
														<small
															:class="{
																charactercount: true,
																errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_2 ) > 40
															}"
														>
															{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_2 ) }}/40
														</small>
														<span class="text-danger" v-if="errors.length">
															{{ errors[0].replace( '{field}', 'Physician Address 2' ) }}
														</span>
													</ValidationProvider>
												</div>
												<div class="col-xs-6">
													<ValidationProvider
														rules="max:40"
														ref="provider"
														v-slot="{ errors }"
													>
														<label for="physicianCity">
															{{ cityText }}
														</label>
														<input
															type="text"
															name="physicianCity"
															maxlength="40"
															class="form-control"
															:aria-label="cityText"
															v-model="formData.PHYSICIANS.PHYSICIAN_ADDRESS_CITY"
															:disabled="isReadOnly"
														/>
														<small
															:class="{
																charactercount: true,
																errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_CITY ) > 40
															}"
														>
															{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_CITY ) }}/40
														</small>
														<span class="text-danger" v-if="errors.length">
															{{ errors[0].replace( '{field}', 'Physician City' ) }}
														</span>
													</ValidationProvider>
												</div>
												<div class="col-xs-6">
													<ValidationProvider ref="provider">
														<label for="physicianState">{{ stateText }}</label>
														<select
															name="physicianState"
															class="form-control"
															:aria-label="stateText"
															v-model="formData.PHYSICIANS.PHYSICIAN_ADDRESS_STATE"
															:disabled="isReadOnly"
														>
															<option v-for="(state, stateIndex) in states"
																			:value="state.STATE_CODE"
																			:key="`state_${state.STATE_CODE}_ ${stateIndex}`">
																{{ state.STATE_DESC }}
															</option>
														</select>
														<div
															class="state_spacer"
														/>
													</ValidationProvider>
												</div>
												<div class="col-xs-6">
													<ValidationProvider
														rules="max:5"
														ref="provider"
														v-slot="{ errors }"
													>
														<label for="zipCode">
															{{ zipCodeText }}
														</label>
														<input
															type="text"
															name="zipCode"
															maxlength="5"
															class="form-control"
															:aria-label="zipCodeText"
															v-model="formData.PHYSICIANS.PHYSICIAN_ADDRESS_ZIP"
															:disabled="isReadOnly"
														/>
														<small
															:class="{
																charactercount: true,
																errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_ZIP ) > 5
															}"
														>
															{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_ZIP ) }}/5
														</small>
														<span class="text-danger" v-if="errors.length">
															{{ errors[0].replace( '{field}', 'Physician Zip Code' ) }}
														</span>
													</ValidationProvider>
												</div>
												<div class="col-xs-5 col-md-2">
													<ValidationProvider
														rules="max:5"
														ref="provider"
														v-slot="{ errors }"
													>
														<label for="zipCodeExtension">
															{{ extText }}
														</label>
														<input
															type="text"
															name="zipCodeExtension"
															maxlength="5"
															class="form-control"
															:aria-label="zipCodeExtensionText"
															v-model="formData.PHYSICIANS.PHYSICIAN_ADDRESS_ZIP_EXT"
														/>
														<small
															:class="{
																charactercount: true,
																errorfont: countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_ZIP_EXT ) > 5
															}"
														>
															{{ countCharacterLength( formData.PHYSICIANS.PHYSICIAN_ADDRESS_ZIP_EXT ) }}/5
														</small>
														<span class="text-danger" v-if="errors.length">
															{{ errors[0].replace( '{field}', 'Physician Zip Ext' ) }}
														</span>
													</ValidationProvider>
												</div>
											</div>
										</panel-basic>
									</div>
								</div>
							</div>
						</panel-basic>
						<!-- Dentist -->
						<panel-basic title="Dentist"
							v-if="showDentistFlag"
												:collapsable="true"
												id="dentist"
												class="rounded-top"
												panelClass="full-height"
												style="border-radius: 25px 25px 0 0;">
							<div class="row">
								<div class="col-xs-12 col-md-4">
									<ValidationProvider
										rules="max:50"
										ref="provider"
										v-slot="{ errors }"
									>
										<label for="physicianDentistName">
											{{ physicianNameText }}
										</label>
										<input
											type="text"
											name="physicianDentistName"
											maxlength="50"
											class="form-control"
											:aria-label="physicianNameText"
											v-model="formData.DENTISTS.PHYSICIAN_NAME"
											:disabled="isReadOnly"
										/>
										<small
											:class="{
												charactercount: true,
												errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_NAME ) > 50
											}"
										>
											{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_NAME ) }}/50
										</small>
										<span class="text-danger" v-if="errors.length">
											{{ errors[0].replace( '{field}', physicianNameText ) }}
										</span>
									</ValidationProvider>
								</div>
								<div class="col-xs-12 col-md-4">
									<div class="row">
										<div class="col-xs-9">
											<ValidationProvider
												rules="max:15"
												ref="provider"
												v-slot="{ errors }"
											>
												<label for="physicianDentistPhoneNumber">
													{{ physicianPhoneText }}
												</label>
												<input
													type="text"
													name="physicianDentistPhoneNumber"
													maxlength="15"
													class="form-control"
													:aria-label="physicianPhoneText"
													v-model="formData.DENTISTS.PHYSICIAN_PHONE_NO"
													:disabled="isReadOnly"
												/>
												<small
													:class="{
														charactercount: true,
														errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_PHONE_NO ) > 15
													}"
												>
													{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_PHONE_NO ) }}/15
												</small>
												<span class="text-danger" v-if="errors.length">
													{{ errors[0].replace( '{field}', physicianPhoneText ) }}
												</span>
											</ValidationProvider>
										</div>
										<div class="col-xs-3">
											<ValidationProvider
												rules="max:5"
												ref="provider"
												v-slot="{ errors }"
											>
												<label for="physicianDentistPhoneExtension">
													{{ extText }}
												</label>
												<input
													type="text"
													name="physicianDentistPhoneExtension"
													maxlength="5"
													class="form-control"
													:aria-label="phoneNumberExtensionText"
													v-model="formData.DENTISTS.PHYSICIAN_PHONE_EXT"
													:disabled="isReadOnly"
												/>
												<small
													:class="{
														charactercount: true,
														errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_PHONE_EXT ) > 5
													}"
												>
													{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_PHONE_EXT ) }}/5
												</small>
												<span class="text-danger" v-if="errors.length">
													{{ errors[0].replace( '{field}', phoneNumberExtensionText ) }}
												</span>
											</ValidationProvider>
										</div>
									</div>
								</div>
								<div class="col-xs-12 col-md-4">
									<div class="row">
										<div class="col-xs-9">
											<ValidationProvider
												rules="max:15"
												ref="provider"
												v-slot="{ errors }"
											>
												<label for="physicianDentistFaxNumber">
													{{ physicianFaxText }}
												</label>
												<input
													type="text"
													name="physicianDentistFaxNumber"
													maxlength="15"
													class="form-control"
													:aria-label="physicianFaxNumberText"
													v-model="formData.DENTISTS.PHYSICIAN_FAX_NO"
													:disabled="isReadOnly"
												/>
												<small
													:class="{
														charactercount: true,
														errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_FAX_NO ) > 15
													}"
												>
													{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_FAX_NO ) }}/15
												</small>
												<span class="text-danger" v-if="errors.length">
													{{ errors[0].replace( '{field}', physicianFaxNumberText ) }}
												</span>
											</ValidationProvider>
										</div>
										<div class="col-xs-3">
											<ValidationProvider
												rules="max:5"
												ref="provider"
												v-slot="{ errors }"
											>
												<label for="physicianDentistFaxExtension">
													{{ extText }}
												</label>
												<input
													type="text"
													name="physicianDentistFaxExtension"
													maxlength="5"
													class="form-control"
													:aria-label="physicianFaxNumberExtensionText"
													v-model="formData.DENTISTS.PHYSICIAN_FAX_EXT"
													:disabled="isReadOnly"
												/>
												<small
													:class="{
														charactercount: true,
														errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_FAX_EXT ) > 5
													}"
												>
													{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_FAX_EXT ) }}/5
												</small>
												<span class="text-danger" v-if="errors.length">
													{{ errors[0].replace( '{field}', physicianFaxNumberExtensionText ) }}
												</span>
											</ValidationProvider>
										</div>
									</div>
								</div>
								<!-- Address -->
								<div class="row" style="margin: 0;">
									<div class="col-xs-12">
										<br />
										<panel-basic
											title="Address"
											:collapsable="true"
											id="physicianDentistAddress"
											class="rounded-top"
											style="border-radius: 25px 25px 0 0;"
										>
											<div class="row">
												<div class="col-xs-12 col-lg-6">
													<ValidationProvider
														rules="max:40"
														ref="provider"
														v-slot="{ errors }"
													>
														<label for="physicianDentistAddressOne">
															{{ addressOneText }}
														</label>
														<input
															type="text"
															name="physicianDentistAddressOne"
															maxlength="40"
															class="form-control"
															:aria-label="addressOneText"
															v-model="formData.DENTISTS.PHYSICIAN_ADDRESS_1"
															:disabled="isReadOnly"
														/>
														<small
															:class="{
																charactercount: true,
																errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_1 ) > 40
															}"
														>
															{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_1 ) }}/40
														</small>
														<span class="text-danger" v-if="errors.length">
															{{ errors[0].replace( '{field}', addressOneText ) }}
														</span>
													</ValidationProvider>
												</div>
												<div class="col-xs-12 col-lg-6">
													<ValidationProvider
														rules="max:40"
														ref="provider"
														v-slot="{ errors }"
													>
														<label for="physicianDentistAddressTwo">
															{{ addressTwoText }}
														</label>
														<input
															type="text"
															name="physicianDentistAddressTwo"
															maxlength="40"
															class="form-control"
															:aria-label="addressTwoText"
															v-model="formData.DENTISTS.PHYSICIAN_ADDRESS_2"
															:disabled="isReadOnly"
														/>
														<small
															:class="{
																charactercount: true,
																errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_2 ) > 40
															}"
														>
															{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_2 ) }}/40
														</small>
														<span class="text-danger" v-if="errors.length">
															{{ errors[0].replace( '{field}', addressTwoText ) }}
														</span>
													</ValidationProvider>
												</div>
												<div class="col-xs-6">
													<ValidationProvider
														rules="max:40"
														ref="provider"
														v-slot="{ errors }"
													>
														<label for="physicianDentistCity">
															{{ cityText }}
														</label>
														<input
															type="text"
															name="physicianDentistCity"
															maxlength="40"
															class="form-control"
															:aria-label="cityText"
															v-model="formData.DENTISTS.PHYSICIAN_ADDRESS_CITY"
															:disabled="isReadOnly"
														/>
														<small
															:class="{
																charactercount: true,
																errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_CITY ) > 40
															}"
														>
															{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_CITY ) }}/40
														</small>
														<span
															class="text-danger"
															v-if="errors.length"
														>
															{{ errors[0].replace( '{field}', cityText ) }}
														</span>
													</ValidationProvider>
												</div>
												<div class="col-xs-6">
													<ValidationProvider ref="provider">
														<label for="physicianDentistState">
															{{ stateText }}
														</label>
														<select
															name="physicianDentistState"
															class="form-control"
															:aria-label="stateText"
															v-model="formData.DENTISTS.PHYSICIAN_ADDRESS_STATE"
															:disabled="isReadOnly"
														>
															<option
																v-for="(state, stateIndex) in states"
																:value="state.STATE_CODE"
																:key="`state_${state.STATE_CODE}_ ${stateIndex}`"
															>
																{{ state.STATE_DESC }}
															</option>
														</select>
														<div
															class="state_spacer"
														/>
													</ValidationProvider>
												</div>
												<div class="col-xs-6">
													<div class="row">
														<div class="col-xs-8">
															<ValidationProvider
																rules="max:5"
																ref="provider"
																v-slot="{ errors }"
															>
																<label for="zipCodeDentist">
																	{{ zipCodeText }}
																</label>
																<input
																	type="text"
																	name="zipCodeDentist"
																	maxlength="5"
																	class="form-control"
																	:aria-label="zipCodeText"
																	v-model="formData.DENTISTS.PHYSICIAN_ADDRESS_ZIP"
																	:disabled="isReadOnly"
																/>
																<small
																	:class="{
																		charactercount: true,
																		errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_ZIP ) > 5
																	}"
																>
																	{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_ZIP ) }}/5
																</small>
																<span class="text-danger" v-if="errors.length">
																	{{ errors[0].replace( '{field}', zipCodeText ) }}
																</span>
															</ValidationProvider>
														</div>
														<div class="col-xs-1">
															<label for="hyphen" style="min-height: 19px;"></label>
															<p name="hyphen"
																class="form-control"
																style="border: none; box-shadow: none; -webkit-box-shadow: none;">
																-
															</p>
														</div>
														<div class="col-xs-3">
															<ValidationProvider
																rules="max:5"
																ref="provider"
																v-slot="{ errors }"
															>
																<label
																	for="zipCodeExtensionDentist"
																	style="min-height: 19px;"
																>
																</label>
																<input
																	type="text"
																	name="zipCodeExtensionDentist"
																	maxlength="5"
																	class="form-control"
																	:aria-label="zipCodeExtensionText"
																	v-model="formData.DENTISTS.PHYSICIAN_ADDRESS_ZIP_EXT"
																	:disabled="isReadOnly"
																/>
																<small
																	:class="{
																		charactercount: true,
																		errorfont: countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_ZIP_EXT ) > 5
																	}"
																>
																	{{ countCharacterLength( formData.DENTISTS.PHYSICIAN_ADDRESS_ZIP_EXT ) }}/5
																</small>
																<span class="text-danger" v-if="errors.length">
																	{{ errors[0].replace( '{field}', zipCodeExtensionText ) }}
																</span>
															</ValidationProvider>
														</div>
													</div>
												</div>
											</div>
										</panel-basic>
									</div>
								</div>
							</div>
						</panel-basic>
					</panel-basic>
				</ValidationObserver>
			</div>
		</div>
	</div>
</template>

<script>
	import PanelBasic from '../panels/PanelBasic.vue';
	import { ValidationObserver, ValidationProvider } from 'vee-validate';

	export default {
		name: 'SISStudentMedical',
		props: {
			formData: {
				type: Object,
				required: true
			},
			hospitals: {
				type: Array,
				required: true
			},
			states: {
				type: Array,
				required: true
			},
			title: {
				type: String,
				required: true
			},
			showInsuranceFlag: {
				type: Boolean,
				default: true,
			},
			showHospitalPreferenceFlag: {
				type: Boolean,
				default: true,
			},
			showPhysicianFlag: {
				type: Boolean,
				default: true,
			},
			showDentistFlag: {
				type: Boolean,
				default: true,
			},
			helpText: {
				type: String,
				default: "",
			},
			insuranceCompanyText: {
				type: String,
				default: "Insurance Company"
			},
			policyNumberText: {
				type: String,
				default: "Policy Number"
			},
			idNumberText: {
				type: String,
				default: "ID Number"
			},
			groupNumberText: {
				type: String,
				default: "Group Number"
			},
			hospitalPreferenceText: {
				type: String,
				default: "Hospital Preference"
			},
			physicianNameText: {
				type: String,
				default: "Physician Name"
			},
			physicianPhoneText: {
				type: String,
				default: "Physician Phone"
			},
			extText: {
				type: String,
				default: "Ext."
			},
			physicianFaxText: {
				type: String,
				default: "Physician Fax"
			},
			physicianFaxNumberText: {
				type: String,
				default: "Physician Fax Number"
			},
			addressOneText: {
				type: String,
				default: "Address 1"
			},
			addressTwoText: {
				type: String,
				default: "Address 2"
			},
			stateText: {
				type: String,
				default: "State"
			},
			cityText: {
				type: String,
				default: "City"
			},
			zipCodeText: {
				type: String,
				default: "Zip Code"
			},
			zipCodeExtensionText: {
				type: String,
				default: "Zip code extension"
			},
			phoneNumberExtensionText: {
				type: String,
				default: "Phone Number Extension"
			},
			physicianFaxNumberExtensionText: {
				type: String,
				default: "Physician Fax Extension"
			},
			isReadOnly:{
				type:Boolean,
				default:false
			}
		},
		methods: {
			countCharacterLength( val ) {
				switch( typeof val ) {
					case "string":
						return val.length;
					case "number":
						return val.toString().length;
					default:
						return 0;
				}
			},
			defaultStateSelection() {
				if( "DENTISTS" in this.formData ) {
					if( "PHYSICIAN_ADDRESS_STATE" in this.formData.DENTISTS ) {
						if( this.formData.DENTISTS.PHYSICIAN_ADDRESS_STATE.length === 0 ) {
							this.formData.DENTISTS.PHYSICIAN_ADDRESS_STATE = "PA";
						}
					} else {
						this.formData.DENTISTS.PHYSICIAN_ADDRESS_STATE = "PA";
					}
				}

				if( "PHYSICIANS" in this.formData ) {
					if( "PHYSICIAN_ADDRESS_STATE" in this.formData.PHYSICIANS ) {
						if( this.formData.PHYSICIANS.PHYSICIAN_ADDRESS_STATE.length === 0 ) {
							this.formData.PHYSICIANS.PHYSICIAN_ADDRESS_STATE = "PA";
						}
					} else {
						this.formData.PHYSICIANS.PHYSICIAN_ADDRESS_STATE = "PA";
					}
				}
			}
		},
		mounted() {
			// Trigger validation for all fields when the component mounts
			this.$refs.observer.validate();

			this.defaultStateSelection();
		},
		components: {
			PanelBasic,
			ValidationObserver,
			ValidationProvider,
		}
	}
</script>

<style scoped>
	.charactercount {
		font-size: 10px;
	}

	.errorfont {
		color: red;
	}

	.state_spacer {
		min-height: 20px;
	}
</style>
